/**
 * Named input actions — the web equivalent of Unity's
 * `Runtime/Infrastructure/CampfireActionNames.cs`.
 *
 * Feature code MUST consult these constants instead of hard-coding key codes
 * (`event.key === "Delete"`). Mirrors the Unity rule:
 *   "Map keyboard shortcuts through named actions, not raw keys."
 *
 * Bindings are defined in `defaultBindings.ts` and loaded by `InputService`
 * at construction. Future per-platform overrides (mac vs windows) live in the
 * same module — never in the consuming feature.
 */

export const CampfireActions = {
  Multiselect: "multiselect",
  Rangeselect: "rangeselect",
  SelectAll: "selectAll",
  Delete: "delete",
  Copy: "copy",
  Paste: "paste",
  Duplicate: "duplicate",
  Undo: "undo",
  Redo: "redo",
  Submit: "submit",
  Cancel: "cancel",
  FocusSelection: "focusSelection",
  ResetCamera: "resetCamera",
  ToggleHierarchy: "toggleHierarchy",
  ToggleInspector: "toggleInspector",
} as const;

export type CampfireAction = (typeof CampfireActions)[keyof typeof CampfireActions];
